import { setCookie, getCookie } from "../../helpers/cookieHelpers";

const themeToggle = () => {
	const motionToggle = document.getElementById("motion-toggle");
	const toggleSvgOn = document.getElementById("toggle-svg-on");
	const toggleSvgOff = document.getElementById("toggle-svg-off");

	// check if the cookie exists = > if not, set it to true
	if (!getCookie("theme--default")) {
		setCookie("theme--default", "true", 365 * 10, "/");
	}

	// retrieve the current cookie value
	let defaultTheme = getCookie("theme--default") === "true";

	const updateToggleSvg = (onToggle, offToggle) => {
		onToggle.classList.add("on");
		onToggle.classList.remove("off");
		offToggle.classList.add("off");
		offToggle.classList.remove("on");
	};

	const updateStyleTheme = () => {
		if (defaultTheme) {
			document.body.classList.add("theme--default");
			document.body.classList.remove("theme--light");
		} else {
			document.body.classList.add("theme--light");
			document.body.classList.remove("theme--default");
		}
	};

	const updateAnimationState = () => {
		if (defaultTheme) {
			motionToggle.setAttribute("aria-checked", "true");
			updateToggleSvg(toggleSvgOn, toggleSvgOff);
			setCookie("theme--default", "true", 365 * 10, "/");
		} else {
			motionToggle.setAttribute("aria-checked", "false");
			updateToggleSvg(toggleSvgOff, toggleSvgOn);
			setCookie("theme--default", "false", 365 * 10, "/");
		}
	};

	motionToggle.addEventListener("click", () => {
		// toggle the theme state
		defaultTheme = !defaultTheme;

		// update state and style
		updateAnimationState();
		updateStyleTheme();
	});

	updateAnimationState();
	updateStyleTheme();
};

export default themeToggle;
